import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

type AuthTabsProps = {
  value: "email" | "phone";
  onChange: (value: "email" | "phone") => void;
};

const AuthTabs = ({ value, onChange }: AuthTabsProps) => {
  return (
    <Tabs value={value} onValueChange={onChange as (value: string) => void}>
      <TabsList className="h-auto w-full rounded-none border-b bg-transparent p-0">
        <TabsTrigger
          value="email"
          className="flex-1 rounded-none border-b-[2.5px] border-transparent bg-transparent px-0 pb-3 pt-0 text-[17px] font-semibold text-[#898D91] shadow-none transition-all outline-none data-[state=active]:border-[#0B9BFF] data-[state=active]:text-[#0B9BFF] data-[state=active]:shadow-none focus-visible:ring-0 focus-visible:ring-offset-0 sm:pb-[11px] sm:text-[18px]"
        >
          Email
        </TabsTrigger>

        <TabsTrigger
          value="phone"
          className="flex-1 rounded-none border-b-[2.5px] border-transparent bg-transparent px-0 pb-3 pt-0 text-[17px] font-semibold text-[#898D91] shadow-none transition-all outline-none data-[state=active]:border-[#0B9BFF] data-[state=active]:text-[#0B9BFF] data-[state=active]:shadow-none focus-visible:ring-0 focus-visible:ring-offset-0 sm:pb-[11px] sm:text-[18px]"
        >
          Phone
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
};

export default AuthTabs;
